<template>
  <nav-link :to="campaignLink">
    <pane>
      <h3 class="text-primary font-normal normal-case mb-1">
        {{ campaignRegistration?.campaign?.name }}
      </h3>
      <span>
        {{ $t("pages.driver.campaignList.more") }}<arrow class="arrow inline ml-2" />
      </span>
      <div class="text-pre mt-11">
        <template
          v-if="campaignRegistration?.campaign.region"
        >
          {{ $t("region") }}: {{ campaignRegistration?.campaign?.region?.name }} |
        </template>
        {{ $t("pages.driver.campaignList.duration") }}:
        {{
          campaignRegistration?.campaign &&
            format(new Date(campaignRegistration?.campaign?.actualStartDate), "dd.MM.yyyy")
        }}
        -
        {{
          campaignRegistration?.campaign &&
            format(new Date(campaignRegistration?.campaign?.actualEndDate), "dd.MM.yyyy")
        }}
      </div>
    </pane>
  </nav-link>
</template>

<script lang="ts" setup>
import Pane from '@components/utils/Pane.vue';
import Arrow from '@images/arrow.svg?component';
import { computed } from 'vue';
import NavLink from '@components/structure/navigation/NavLink.vue';
import { format } from 'date-fns';
import type { CampaignRegistration } from '@/entities/Entities';

interface Props {
  campaignRegistration?: CampaignRegistration;
}

const props = defineProps<Props>();

const campaignLink = computed(() => `/campaigns/campaign-groups/${props.campaignRegistration?.campaign.group.id}`);
</script>

<style lang="scss" scoped>
.arrow {
  @apply text-primary;
  width: px(15);
  height: px(10);

  :deep(path) {
    fill: currentColor;
    stroke: currentColor;
  }
}
</style>
